import { EmptyButton, RoundButton, roundButtonStylesLarge } from "@smartsuite/react-ui/lib";
import cx from "classnames";
import { type FC, useCallback } from "react";

const BACK_LABEL = "Back";
const NEXT_LABEL = "Next";

interface FormPageNavigationProps {
  isFirstPage: boolean;
  isLastPage: boolean;
  isSinglePage: boolean;
  isSubmitting: boolean;
  submitLabel: string;
  backLabel?: string;
  forcePrimarySubmit?: boolean;
  nextLabel?: string;
  onNext: () => void;
  onPrevious: () => void;
  onSubmit: () => void;
}

export const FormPageNavigation: FC<FormPageNavigationProps> = ({
  isFirstPage,
  isLastPage,
  isSinglePage,
  isSubmitting,
  submitLabel,
  backLabel = BACK_LABEL,
  forcePrimarySubmit = false,
  nextLabel = NEXT_LABEL,
  onNext,
  onPrevious,
  onSubmit,
}) => {
  const showPrevious = !isFirstPage;
  const isPrimarySubmit = forcePrimarySubmit || isLastPage || isSinglePage;

  const handlePrevious = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      onPrevious();
    },
    [onPrevious],
  );

  const handlePrimaryClick = useCallback(
    (e: React.MouseEvent) => {
      if (!isPrimarySubmit) {
        e.preventDefault();
        onNext();
      } else {
        onSubmit();
      }
    },
    [isPrimarySubmit, onNext, onSubmit],
  );

  const classes = cx("form__footer", "form__footer--multi-page", {
    "form__footer--has-back": showPrevious,
  });

  return (
    <div className={classes}>
      {showPrevious && (
        <EmptyButton className="form__button--back" size="lg" onClick={handlePrevious}>
          {backLabel}
        </EmptyButton>
      )}

      <RoundButton
        className="form__button--save"
        styles={roundButtonStylesLarge}
        loading={isPrimarySubmit ? isSubmitting : false}
        onClick={handlePrimaryClick}
      >
        {isPrimarySubmit ? submitLabel : nextLabel}
      </RoundButton>
    </div>
  );
};
